import {Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerService, CustomerView } from '../../../api';

@Component({
    selector: 't4-customer-barcode-search-dialog',
    templateUrl: 'customer-barcode-search-dialog.component.html',
    standalone: false
})

export class CustomerBarcodeSearchDialogComponent implements OnInit {
  public barcode: string='';
  public values: string[] =[];
  public notFound = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private customerService: CustomerService,
    public dialogRef: MatDialogRef<CustomerBarcodeSearchDialogComponent>
  ) { }

  ngOnInit() {
  }
  ngAfterViewInit() {
    document.getElementById('barcode').focus();
  }

  onKey(event: any) {
    if (this.barcode == event.target.value) {
      // @ts-ignore
      document.getElementById('barcode').select();
      document.getElementById('barcode').focus();
      return;
    }

    this.barcode = event.target.value;

    if (this.barcode !== '' && this.barcode) {
      this.getCustomer();
    }
  }
  getCustomer() {
    this.customerService.getCustomerWithHardCard(this.barcode).subscribe((resp: CustomerView) => {
      if (resp != null) {
        this.dialogRef.close(resp);
        return;
      }

      this.notFound = true;
      // @ts-ignore
      document.getElementById('barcode').select();
      document.getElementById('barcode').focus();
    });
  }
}
